"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_device_detect_1 = require("react-device-detect");
exports.default = react_device_detect_1.isIOS
    ? 'itms-apps://apps.apple.com/kr/app/폰디/id1606722784'
    : 'https://play.google.com/store/apps/details?id=com.fondee';
